import React, { useState, useEffect } from "react";
import axios from "axios";
import OBReport from "./OBUpdatedDetails";

export default function OBDetailsTable({ data, month, year, fpsId, distName, officeName, monthInt, commodities }) {
  const [rows, setRows] = useState(
    data.data.map((row) => ({
      ...row,
      newOb: row.new_ob ? Number(row.new_ob).toFixed(3) : "0.000",
      oldOb: row.ob ? Number(row.ob).toFixed(3) : "0.000",
      received_qty: row.received_qty ? Number(row.received_qty).toFixed(3) : "0.000",
      issued: row.issued ? Number(row.issued).toFixed(3) : "0.000",
      sixa_case: row.sixa_case ? Number(row.sixa_case).toFixed(3) : "0.000",
    }))
  );
  const [reportData, setReportData] = useState(null);

  const monthname = (monthNum) => {
    return new Date(2000, monthNum - 1).toLocaleString('default', { month: 'long' });
  };
  // Reset rows and reportData when new data is received
  useEffect(() => {
    setRows(
      data.data.map((row) => ({
        ...row,
        newOb: row.new_ob ? Number(row.new_ob).toFixed(3) : "0.000",
        oldOb: row.ob ? Number(row.ob).toFixed(3) : "0.000",
        received_qty: row.received_qty ? Number(row.received_qty).toFixed(3) : "0.000",
        issued: row.issued ? Number(row.issued).toFixed(3) : "0.000",
        sixa_case: row.sixa_case ? Number(row.sixa_case).toFixed(3) : "0.000",
      }))
    );
    setReportData(null);
  }, [data]);

  const handleChange = (index, value) => {
    // Allow empty input temporarily for user convenience
    if (value === "") {
      const updated = [...rows];
      updated[index].newOb = "";
      setRows(updated);
      return;
    }

    // Validate decimal number with up to 3 decimal places
    const decimalRegex = /^\d*\.?\d{0,3}$/;
    if (!decimalRegex.test(value) || value.includes("..")) {
      // toast.error("New OB must be a valid number with up to 3 decimal places");
      alert("New OB must be a valid number with up to 3 decimal places");
      return;
    }

    const newOb = parseFloat(value);
    if (isNaN(newOb) || newOb < 0) {
      // toast.error("New OB cannot be negative");
      alert("New OB cannot be negative");
      return;
    }


    const updated = [...rows];
    updated[index].newOb = value;
    setRows(updated);
  };

  const handleSubmit = async () => {
    // Validate all fields
    for (let row of rows) {
      if (row.newOb === "" || isNaN(parseFloat(row.newOb))) {
        // toast.error(`Please enter a valid New OB for ${row.comm_short_name}`);
        alert(`Please enter a valid New OB for ${row.comm_short_name}`);
        return;
      }

      // Validate closing balance (newOb + received_qty + sixa_case - issued)
      // const newOb = parseFloat(row.newOb);
      // const cb =
      //   newOb +
      //   parseFloat(row.received_qty || 0) +
      //   parseFloat(row.sixa_case || 0) -
      //   parseFloat(row.issued || 0);
      // if (cb < 0) {
      //   // toast.error(`New OB would result in negative closing balance for ${row.comm_short_name}`);
      //   alert(`New OB would result in negative closing balance for ${row.comm_short_name}`);
      //   return;
      // }

    }
    if (!window.confirm("Check once before final submission!")) return;

    const payload = {
      fpsId,
      month,
      year,
      commodities: rows.map((row) => ({
        comm_short_name: row.comm_short_name,
        scheme_short_name: row.scheme_short_name,
        commId: parseInt(row.comm_id),
        schemeId: parseInt(row.scheme_id),
        newOb: parseFloat(row.newOb),
        oldOb: parseFloat(row.oldOb),
      })),
    };

    try {
      const res = await axios.post(`${process.env.REACT_APP_URL}/api/ob/update`, payload, {
        headers: {
          'X-React-Route': window.location.href
        }
      });
      setReportData({
        ...res,
        fpsId,
        month,
        year,
        distName,
        officeName,
      });
      alert(res.data.message || "OB Updated Successfully");
      // toast.success(res.data.message || "OB Updated Successfully");
    } catch (err) {
      console.error("Update failed:", err);
      const errorMessage = err.response?.data?.error || "OB Update failed. Please try again.";
      alert(errorMessage);
      // toast.error(errorMessage);
    }
  };

  if (reportData) {
    return <OBReport {...reportData} />;
  }
  if (!commodities || commodities == 0) {
    console.log("commodities", commodities)
    return (
      <div align='center' className="response">
        <p>No commodities are enabled</p>
      </div>
    );
  }

  if (commodities > 0 && rows.length === 0) {
    return (
      <div align='center' className="response">
        <p>
          Stock Details not found for FPS: <span >{fpsId}</span>
        </p>
      </div>
    );
  }

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <table className="min-w-full border-collapse bg-white shadow-md rounded-lg">
        <thead>
          <tr className="tableheader">
            <th colSpan="6" className="p-3 text-center text-lg font-semibold">
              OB Details for FPS: <span className="text-orange-500">{fpsId}</span>
              (District: {distName} / Taluk: {officeName}) / {monthname(monthInt)} {year}
            </th>
          </tr>
          <tr className="tableheader">
            <th className="p-2">Sl.No</th>
            <th className="p-2">Commodity</th>
            <th className="p-2">Scheme</th>
            <th className="p-2">CB (in Kgs)</th>
            <th className="p-2">Existing OB (in Kgs)</th>
            <th className="p-2">Enter New OB (in Kgs)</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index} className="border-b hover:bg-gray-50">
              <td className="p-2 text-center">{index + 1}</td>
              <td className="p-2">{row.comm_short_name}</td>
              <td className="p-2">{row.scheme_short_name}</td>
              <td className="p-2 text-right">{row.cb}</td>
              <td className="p-2 text-right">{row.oldOb}</td>
              <td className="p-2">
                <input
                  type="text"
                  maxLength="9"
                  value={row.newOb}
                  onChange={(e) => handleChange(index, e.target.value)}
                  placeholder="0.000"
                />
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="6" className="p-3">
              <div className="flex flex-col items-center gap-4">
                <button
                  onClick={handleSubmit}
                  className="button"
                >
                  Submit
                </button>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}